module.exports = __webpack_public_path__ + "media/images/flags/4x3/usa-5cc5f3b454908f4f269255181f2a7292.svg";